import type {ChatState} from "./ChatState.js";
import {MessageFactory} from "../factory/MessageFactory.js";
import type {SessionItem} from "../session/SessionItem.js";
import {ref} from "vue";
import SSEClient from "../SSEComponent/SSEClient.js";
import {PredictSSEDataAdapter} from "../SSEComponent/PredictSSEDataAdapter.js";
import type {OnSSEConnectListener} from "../listener/OnSSEConnectListener.js";

export class AgentState implements ChatState{

    async handler(text: string, session: SessionItem) {

        const msg = ref(MessageFactory.createAiMsg())
        msg.value.isStreaming = true
        session.pushMessage(msg.value)

        const url = new URL("/api/mcframeAI/predict", window.location.origin)
        url.searchParams.set("question", text)

        const sseClient = new SSEClient(url)
        sseClient.registerAdapter(new PredictSSEDataAdapter(session))
        sseClient.connect()

    }

}